import { connect } from 'react-redux'
import {
  compose, lifecycle, withState, withHandlers,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration, updateSiteConfigs } from 'actions/Site'
import { fetchBannerApps } from 'actions/BannerApps'
import BannerAppsView from 'components/pages/webManagement/bannerApps/List'
import { message } from 'antd'

export function mapStateToProps(state) {
  const { currentUser } = state.root.auth
  return {
    currentUser,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchBannerApps: bindActionCreators(fetchBannerApps, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('bannerAppsList', 'setBannerAppsList', {
    data: [],
    meta: {},
    isFetching: true,
  }),
  withHandlers({
    getBannerApps: props => (params) => {
      props.fetchBannerApps(params)
        .then((result) => {
          props.setBannerAppsList({
            data: [result.data],
            meta: result.meta,
            isFetching: false,
          })
        })
        .catch((error) => {
          props.setBannerAppsList({
            data: [],
            meta: {},
            isFetching: false,
          })
          message.error(error.message)
        })
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Web Management', 'Banner Apps'])
      this.props.updateSiteConfigs({
        titlePage: 'Banner Apps',
        activePage: 'web-management/banner-apps',
        activeSubPage: 'web-management',
      })
      this.props.getBannerApps()
    },
  }),
)(BannerAppsView)
